export default __webpack_public_path__ + "static/media/farmers-market.924bb166.jpg";